import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import { Spinner } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import SelectedChoicesContainer from '../SelectedChoices/SelectedChoicesContainer.js';

const AppointmentCustomerForm = ({ className , loading , loggedIn , Form , title , layout , initialFormState , onChange , onSubmit , submitting =false , disableSubmit =false , beforeSubmitSlot =null , formAlert =null ,  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('appointment-customer-form', className)
    }, /*#__PURE__*/ React.createElement(SelectedChoicesContainer, null), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "smallest",
        className: "appointment-customer-form__title"
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: "appointment-customer-form__container",
        "aria-live": "polite"
    }, loading ? /*#__PURE__*/ React.createElement("div", {
        className: "appointment-customer-form__loader"
    }, /*#__PURE__*/ React.createElement(Spinner, {
        "aria-label": getLabel('common.loadingText')
    })) : Form && /*#__PURE__*/ React.createElement(Form, {
        className: "appointment-customer-form__content",
        name: "bookAppointment",
        initialFormState: initialFormState,
        layout: layout,
        loggedIn: loggedIn,
        submitting: submitting,
        disableSubmit: disableSubmit,
        beforeSubmitSlot: beforeSubmitSlot,
        formAlert: formAlert,
        onChange: onChange,
        onSubmit: onSubmit
    })));
};

export { AppointmentCustomerForm, AppointmentCustomerForm as default };
//# sourceMappingURL=AppointmentCustomerForm.js.map
